import React from 'react'

import InputErrorsBox from './InputErrorsBox';

export default ({label, errors, ...props}) => {
    return (
        <div>
            <div className="checkbox">
                <label>
                    <input {...props}
                            type="checkbox"/> {label}
                </label>
            </div>
            <InputErrorsBox errors={errors} />
        </div>
    )
}